module.exports = "/_next/static/images/Retail-Display-Solutions-7188650c96f4817abeb7a150f6fa6a7d.jpg";